/* eslint-disable react-hooks/exhaustive-deps */

import { useParams } from "react-router-dom";
import TEXT from "../../../../../utils/globalText";
import AdditionalRecipientCreate from "../../../../AdditionalRecipientCreate";
import AdditionalRecipients from "../../../../_utils/AccountCreationComponents/AdditionalRecipients";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CategoriesEdit from "../../../../_utils/AccountCreationComponents/CategoriesEdit";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonAssignLabelPopup from "../../../../_utils/CommonPopups/CommonAssignLabelPopup";

const BeneficiaryAccountStepCategories = ({
  createRecipient,
  showAdditionalSection,
  initialRecipientCount,
  showAdditionalRecipient,
  setShowAdditionalRecipient,
  handleConfirmRecipients,
  tempRecipients,
  setTempRecipients,
  recipientButtonDisabled,
  setRecipientButtonDisabled,
  additionalChip,
  setAdditionalChip,
  labelpopup,
  handleClose,
  labels,
  setLabels,
  setLabelpopup,
  selectedLabelsCreate,
  setSelectedLabelsCreate,
  labelPopupLoading,
  setLabelPopupLoading,
  selectedCatFields,
  toggleSelection,
  payload,
  openAdditionalRecipients,
  categories,
  setShowAdditionalSection,
}) => {
  const { id } = useParams();

  return (
    <>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipientCreate
            type="createFlow"
            finalRecipients={createRecipient}
            initialRecipientCount={initialRecipientCount}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirmRecipients}
            recipients={tempRecipients}
            setRecipients={setTempRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}

      {labelpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={labelpopup}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="w-width-full">
        <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md">
          <CommonLayout>
            <div className="w-width-full lg:max-w-[var(--create-box-width)]">
              <CategoriesEdit
                type="CategoryCreate"
                sortedCategories={categories}
                selectedCategories={selectedCatFields}
                handleCategorySelect={toggleSelection}
                Title="Categories"
                SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
                TitleFontcolor="text-primary"
                TextSize="font-md"
                SubTitleFontcolor="text-secondary"
                SubTitleTextSize="font-xs"
                TitleFontWeight="semibold"
                SubTitleFontWeight="normal"
              />
            </div>
            <div className="w-width-full lg:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
              <AssignLabels
                setLabelpopup={setLabelpopup}
                labels={payload?.labels}
                subText1={TEXT?.LABELS_ACCOUNT_USAGE_NOTE}
                isOptional
              />
              <AdditionalRecipients
                setShowAdditionalSection={openAdditionalRecipients}
                recipients={createRecipient}
              />
            </div>
          </CommonLayout>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryAccountStepCategories;
